<div [class.disabled]="disabled" [class.untouchedState]="enableUntouchedState && checked === null" class="slideToggleContainer">
	<span
		(click)="setChecked(false)"
		[class.checked]="enableUntouchedState ? checked === false : !checked"
		[matTooltipDisabled]="toolTipFirstOption?.length === 0"
		[matTooltip]="toolTipFirstOption"
		class="firstOption"
		matTooltipClass="accent"
	>
		<ng-content select="[first-option]" />
	</span>

	<mat-slide-toggle (click)="setChecked(true)" [checked]="checked" [disabled]="disabled" appStopPropagation class="example-margin">
		<span
			[matTooltipDisabled]="toolTipSecondOption?.length === 0"
			[matTooltip]="toolTipSecondOption"
			class="secondOption"
			matTooltipClass="accent"
		>
			<ng-content select="[second-option]" />
		</span>
	</mat-slide-toggle>
</div>
